'use client';

import { c as _c } from "react/compiler-runtime";
import { sendGTMEvent } from '@next/third-parties/google';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/common/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/common/dropdown-menu';
import { CalendlyScript, getDataLayerAttribution, openCalendlyPopup, type UtmParams, useCalendlyCSS } from '../Calendly/CalendlyLinks';
type BookingDropdownProps = {
  tourBookingUrl?: string | null;
  callBookingUrl?: string | null;
  className?: string;
  locationName: string;
};
export default function BookingDropdown(t0) {
  const $ = _c(35);
  const {
    tourBookingUrl,
    callBookingUrl,
    className,
    locationName
  } = t0;
  useCalendlyCSS();
  if (!tourBookingUrl && !callBookingUrl) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getDataLayerAttribution();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dataLayerAttribution = t1;
  let t2;
  if ($[1] !== locationName) {
    t2 = {
      ...dataLayerAttribution,
      utm_content: locationName
    };
    $[1] = locationName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const utmParams = t2;
  let t3;
  if ($[3] !== locationName || $[4] !== tourBookingUrl || $[5] !== utmParams) {
    t3 = () => {
      if (tourBookingUrl) {
        openCalendlyPopup(tourBookingUrl, utmParams, "Book a Tour", locationName);
        sendGTMEvent({
          event: "calendly_booking_tour_started",
          location_name: locationName
        });
      }
    };
    $[3] = locationName;
    $[4] = tourBookingUrl;
    $[5] = utmParams;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleTourClick = t3;
  let t4;
  if ($[7] !== callBookingUrl || $[8] !== locationName || $[9] !== utmParams) {
    t4 = () => {
      if (callBookingUrl) {
        openCalendlyPopup(callBookingUrl, utmParams, "Book a Call", locationName);
        sendGTMEvent({
          event: "calendly_booking_call_started",
          location_name: locationName
        });
      }
    };
    $[7] = callBookingUrl;
    $[8] = locationName;
    $[9] = utmParams;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleCallClick = t4;
  if (tourBookingUrl && !callBookingUrl) {
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <CalendlyScript />;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== className || $[13] !== handleTourClick) {
      t6 = <>{t5}<Button variant="inverse" className={className} onClick={handleTourClick}>Book a tour</Button></>;
      $[12] = className;
      $[13] = handleTourClick;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  if (callBookingUrl && !tourBookingUrl) {
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <CalendlyScript />;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== className || $[17] !== handleCallClick) {
      t6 = <>{t5}<Button variant="inverse" className={className} onClick={handleCallClick}>Book a call</Button></>;
      $[16] = className;
      $[17] = handleCallClick;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    return t6;
  }
  let t5;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CalendlyScript />;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const t6 = `${className} w-full`;
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronDown className="ml-2 h-4 w-4" />;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6) {
    t8 = <DropdownMenuTrigger asChild={true}><Button variant="inverse" className={t6}>Book{t7}</Button></DropdownMenuTrigger>;
    $[21] = t6;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== handleTourClick || $[24] !== tourBookingUrl) {
    t9 = tourBookingUrl && <DropdownMenuItem onClick={handleTourClick}>Book a tour</DropdownMenuItem>;
    $[23] = handleTourClick;
    $[24] = tourBookingUrl;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== callBookingUrl || $[27] !== handleCallClick) {
    t10 = callBookingUrl && <DropdownMenuItem onClick={handleCallClick}>Book a call</DropdownMenuItem>;
    $[26] = callBookingUrl;
    $[27] = handleCallClick;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <DropdownMenuContent align="end">{t9}{t10}</DropdownMenuContent>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t8) {
    t12 = <>{t5}<DropdownMenu>{t8}{t11}</DropdownMenu></>;
    $[32] = t11;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}